export class cashPriceObject {
    // eslint-disable-next-line
    constructor() {
    }

    getCashPrice = (params) => {
        const {
            vehiclePrice
        } = params;


        return vehiclePrice;
    }

    getTotalInstallmentRound = (params) => {
        const {
            totalInstallment,

        } = params;

        return Math.ceil(+Number((Math.round((totalInstallment) + "e" + 0)  + "e-" + 0)))
    }

}

export default cashPriceObject;